<template>
	<div class="w-full border-solid border-t-4 border-green-500 rounded-t shadow-md">
		<h2 class="p-4 text-xl bg-white">Active Projects</h2>
		<table class="w-full">
			<thead>
				<th class="mx-4 w-24 text-center">Priority</th>
				<th>Name</th>
				<th>Stage</th>
				<th class="text-right">End Date</th>
			</thead>
			<tbody v-if="activeProjects.length">
				<tr v-for="(project, projectIndex) in activeProjects" :key="projectIndex">
					<td class="mx-4 w-24 flex justify-center">
						<span class="badge font-variant-all-small-caps" :class="project.priority_color">
							{{ project.priority }}
						</span>
					</td>
					<td>
						<a :href="project.view_url" class="font-semibold">{{ project.name }}</a>
					</td>
					<td class="text-base">{{ project.stage }}</td>
					<td class="text-base text-right">{{ project.end_date }}</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr>
					<td colspan="4">
						<div class="text-xl text-center p-6">No Active Projects</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: {
		projects: {
			type: Array,
			required: true
		}
	},

	computed: {
		activeProjects() {
			return _.filter(this.projects, ['status', 'Active']);
		}
	}
}
</script>